import VisitorAnalysisComponent from './VisitorAnalysis.vue'
export default VisitorAnalysisComponent
